import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, Dialog, Typography, CircularProgress } from '@mui/material';
import OtpInput from 'react-otp-input';
import logo from '@src/assets/logo/logo-AiVoice-new.svg';
import { StyledOTPWrapper } from './index.style';

const OTPConfirm = ({ open, onClose, onSubmit, onResendOTP, destination }) => {
  const { t } = useTranslation();
  const [otp, setOtp] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [countdown, setCountdown] = useState(60);
  const [showAgain, setShowAgain] = useState(false);
  let timer;

  const handleChangeOtp = async (otpValue) => {
    setOtp(otpValue);
    setError(false);
    if (otpValue.length === 6) {
      setLoading(true);
      const result = await onSubmit(otpValue);
      if (!result) {
        setError(true);
      }
      setLoading(false);
      setOtp('');
    }
  };

  const startCountdown = () => {
    setShowAgain(false);
    timer = setInterval(() => {
      setCountdown((prev) => {
        if (prev === 1) {
          setShowAgain(true);
          clearInterval(timer);
          return 0;
        }
        return prev - 1;
      });
    }, 1000);
  };

  const handleResendClick = () => {
    clearInterval(timer);
    setCountdown(60);
    startCountdown();
    onResendOTP();
  };

  useEffect(() => {
    if (open) {
      setCountdown(60);
      startCountdown();
      setError(false);
    }

    return () => clearInterval(timer);
  }, [open]);

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        PaperProps={{ style: { borderRadius: '20px', margin: '16px' } }}
      >
        <StyledOTPWrapper error={error}>
          {loading && (
            <div className="loading">
              <CircularProgress />
            </div>
          )}
          <img src={logo} alt="Logo" style={{ width: '100px' }} />
          <Typography className="otp-verify">{t('verifyOTP')}</Typography>
          <Typography
            className="otp-sent"
            dangerouslySetInnerHTML={{
              __html: t('otpSent', { value: destination }),
            }}
          />

          <Box className="otp-wrapper">
            <OtpInput
              value={otp}
              onChange={handleChangeOtp}
              numInputs={6}
              renderInput={(props) => <input {...props} />}
              inputType="tel"
              renderSeparator={<span style={{ width: '8px' }} />}
              shouldAutoFocus
              inputStyle={{
                border: `${
                  error
                    ? '1px solid #FF3B30'
                    : '1px solid rgba(30, 22, 78, 0.16)'
                }`,
                height: '36px',
                width: '36px',
                borderRadius: '12px',
              }}
              placeholder="------"
            />

            <Typography className="error-text">{t('wrongOTP')}</Typography>
          </Box>

          <Typography
            className="not-receive-otp"
            sx={{ cursor: showAgain ? 'pointer' : 'default' }}
          >
            {t('notReceiveOTP')}?{' '}
            <span
              className="not-receive-otp-note"
              role="button"
              tabIndex={0}
              onClick={showAgain ? handleResendClick : undefined}
            >
              {showAgain ? t('resend') : `(${countdown}s)`}
            </span>
          </Typography>
        </StyledOTPWrapper>
      </Dialog>
    </>
  );
};

export default OTPConfirm;
